<div class="floatinghead clearfix">
    <div class="rightside clearfix">
        <div class="search-sec">
            <input class="form-control" type="text" (keyup)="onSearch($event.target.value)" placeholder="Search">
            <i class="fa fa-search icon" aria-hidden="true"></i>
        </div>
    </div>
</div>
<div class="table-responsive">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
        <thead>
            <tr>
                <th>Inquiry Date</th>
                <th>Sale Price</th>
                <th>Sale / Projected Sale Date</th>
                <th>Status</th>
                <th style="width:80px !important;position:static; cursor:auto;" data-orderable="false">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let inquiry of inquiryList;let i = index ">
                <td>
                    <p>{{ valdateService.convertUTCDateToLocalDate(inquiry.InquiryDate)| date:'MM/dd/yyyy' }}</p>
                </td>
                <td>
                    <p>{{ inquiry.SalePrice ? '$ ' + (inquiry.SalePrice | number):'-' }}</p>
                </td>
                <td>
                    <p>{{ inquiry.ProjectedSaleDate ? (valdateService.convertUTCDateToLocalDate(inquiry.ProjectedSaleDate)| date:'MM/dd/yyyy') :'-' }}</p>
                </td>
                <td>
                    <p>{{ inquiry.Status }}</p>
                </td>
                <td class="whitespacenowrap">
                    <div class="btn-group">
                        <a routerLink="/1031-registration/{{inquiry.ExGuid}}" [queryParams]="{prevroute:'1031 Inquiries',link:router.url,parentId:'100'}" tooltip="Edit" placement="top" class="blueone quick-edit"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr *ngIf="inquiryList?.length == 0&&!IsLoading ">
                <td colspan="4" class="odd no-data-available">
                    <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>
